export type MethodParameters = {
    type: string;
    value: MethodParameters;
}[];
